<template>
    <div class="wrapper">
      <div class="row">
      <div class="col-md-3">
        <MultiSelect v-model="selectedOptions" :options="item.values" optionLabel="name" :filter="true" placeholder="Välj lastbilar.." style="width:100%" @change="addItem($event.value)" :dataKey="item.values.id" >
          <template #value="slotProps">
            <div v-if="slotProps.value.length === 1">
                1 lastbil vald
            </div>
            <div v-if="slotProps.value.length > 1">
              {{slotProps.value.length}} lastbilar valda
            </div>
            <div v-if="!slotProps.value || slotProps.value.length === 0">
              <span>Välj lastbilar..</span>
             </div>
          </template>
          <template #option="slotProps">
            <span>{{slotProps.option.name}} {{slotProps.option.type}}</span>
            </template>
        </MultiSelect>
      </div>
      <div class="col-md-9">
        <div class="table-responsive">
          <table class="table-hover orderList">
          <thead>
            <tr>
              <th>Lastbil</th>
              <th>Typ</th>
              <th></th>
            </tr>
          </thead>
          <tr v-for="item in selectedItems" :key="item.id">
            <td>{{ item.name }}</td>
            <td>{{ item.type }}</td>
            <td><a :id="item.id + 'removeItem'" href="#" @click.prevent="removeItem(item)">X</a></td>
          </tr>
        </table>
        </div>
      </div>
      </div>
    </div>
</template>
<script>
import { abstractField } from 'vue-form-generator'
import MultiSelect from 'primevue/multiselect'
import { isNil } from 'lodash'
export default {
  beforeMount () {
    if (isNil(this.value)) {
      this.value = []
    }
  },
  data () {
    return {
      selectedOptions: null
    }
  },
  components: {
    MultiSelect
  },
  mixins: [abstractField],
  created () {
    if (this.value) {
      this.value = this.value.map((el) => ({id: el.id, name: el.name, type: el.type}))
    } else {
      this.value = []
    }
    this.selectedOptions = this.value
  },
  computed: {
    selectedItems: {
      get: function () {
        return this.schema.values.filter((el) => this.value.find(x => x.id === el.id))
      },
      set: function (newValue) {
        return newValue
      }
    },
    item: {
      get: function () {
        return this.schema
      },
      set: function (newValue) {
        return newValue
      }
    }
  },
  methods: {
    addItem (value) {
      this.value = value.map((el) => {
        return typeof el === 'object' ? el : {id: el}
      })
    },
    removeItem (item) {
      this.value.forEach((element, index) => {
        if (element.id === item.id) {
          this.value.splice(this.value.indexOf(item.id), 1)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/vfg-custom-fields/fieldAddTrucks.vue